import { render, staticRenderFns } from "./indexPayment.vue?vue&type=template&id=a5155bd2"
import script from "./indexPayment.vue?vue&type=script&lang=js"
export * from "./indexPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports